import axios from "axios";
import { useEffect, useState } from "react";

export default function AddUser(props){
    
    const id =props.id;
    const [data, setData]=useState([]);
    
    function getData(id){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/plan/secured/getPlan/`+id)
        .then(result=>setData(result.data))
        .catch(err=>console.log(err));
    }
    function submitHandler(e){
       
        e.preventDefault();
        const obj = new FormData(e.target);
        const data = Object.fromEntries(obj.entries()); 
        axios.put(`${process.env.REACT_APP_BASE_URL}api/plan/secured/updatePlan`,data)
        .then(result=>{alert("Edit Successfully!");window.location.href="/plan"})
        .catch(err=>alert(err.response.data));
    }
    useEffect(()=>getData(id),[id]);

    return(<div className="small-form-container container">
            <button className="btn btn-danger" style={{float:"right"}} onClick={()=>props.event(false)}>X</button>
        <div className="text-center">
            <h2>Edit Plan</h2>
        </div><hr />
        <div className="form">
            <form onSubmit={submitHandler}>
                <div className="row">
                        <input type="hidden" name="id" defaultValue={data.id} />
                        <input type="hidden" name="userId" defaultValue={data.userId} />
                        <div>
                            <input className="form-control" type="text" name="planType" placeholder="Plan Type" defaultValue={data.planType} readOnly />
                        </div>
                        <div>
                            <input className="form-control" type="text" name="price" placeholder="Price" defaultValue={data.price} readOnly />
                        </div>
                        <div>
                            <input className="form-control" type="text" name="passkey" placeholder="Passkey" defaultValue={data.passkey} readOnly />
                        </div>
                        <div>
                            <input className="form-control" type="date" name="expiredDate" placeholder="ExpiredDate" required/>
                        </div>
                         <div>
                            <select name="status" className="form-select">
                                <option value="Active">Active</option>
                                <option value="Rejected">Rejected</option>
                            </select>
                        </div>
                        <div>
                            <button className="btn btn-color form-control">Submit</button>
                        </div> 
                </div> 
            </form>
        </div>
    </div>);
}